export enum RouteType {
  Home = 'home',
  Post = 'post',
  Category = 'category',
  Page = 'page',
  NotFound = 'not_found',
}

export enum PreviewType {
  Post = 'post',
  Page = 'page',
}

export type Route = {
  type: RouteType;
  link: string;
  id: number | null;
  path: string;
};

export type Routes = { [key: string]: Route };



// WEBPACK FOOTER //
// ./src/module/Model/Routes/index.ts